import React from "react";

/** Leyenda comercial de la captura asistida por IA, comun al modal y al asistente de carga. */
const IntakeAiBanner = ({ children }) => (
  <div className="di-ai-banner mb-4">
    <i className="fa fa-magic di-ai-icon" />
    <div>
      <div className="font-weight-bold">
        Captura asistida por inteligencia artificial
        <span className="di-ai-chip">IA</span>
      </div>
      <div className="small">{children}</div>
    </div>
  </div>
);

export default IntakeAiBanner;
